/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { SalesBaseService } from '../sales-base-service';
import { SalesApiConfiguration } from '../sales-api-configuration';
import { SalesStrictHttpResponse } from '../sales-strict-http-response';

import { SalesBootstrapPriceListsResponseDto } from '../models/sales-bootstrap-price-lists-response-dto';
import { SalesPriceListResponseDto } from '../models/sales-price-list-response-dto';
import { priceListsControllerAddComplexity } from '../fn/price-lists/price-lists-controller-add-complexity';
import { PriceListsControllerAddComplexity$Params } from '../fn/price-lists/price-lists-controller-add-complexity';
import { priceListsControllerBootstrapPriceLists } from '../fn/price-lists/price-lists-controller-bootstrap-price-lists';
import { PriceListsControllerBootstrapPriceLists$Params } from '../fn/price-lists/price-lists-controller-bootstrap-price-lists';
import { priceListsControllerCreate } from '../fn/price-lists/price-lists-controller-create';
import { PriceListsControllerCreate$Params } from '../fn/price-lists/price-lists-controller-create';
import { priceListsControllerFindAllByTenant } from '../fn/price-lists/price-lists-controller-find-all-by-tenant';
import { PriceListsControllerFindAllByTenant$Params } from '../fn/price-lists/price-lists-controller-find-all-by-tenant';
import { priceListsControllerFindOne } from '../fn/price-lists/price-lists-controller-find-one';
import { PriceListsControllerFindOne$Params } from '../fn/price-lists/price-lists-controller-find-one';
import { priceListsControllerRemove } from '../fn/price-lists/price-lists-controller-remove';
import { PriceListsControllerRemove$Params } from '../fn/price-lists/price-lists-controller-remove';
import { priceListsControllerRemoveComplexity } from '../fn/price-lists/price-lists-controller-remove-complexity';
import { PriceListsControllerRemoveComplexity$Params } from '../fn/price-lists/price-lists-controller-remove-complexity';
import { priceListsControllerUpdate } from '../fn/price-lists/price-lists-controller-update';
import { PriceListsControllerUpdate$Params } from '../fn/price-lists/price-lists-controller-update';
import { priceListsControllerUpdateComplexity } from '../fn/price-lists/price-lists-controller-update-complexity';
import { PriceListsControllerUpdateComplexity$Params } from '../fn/price-lists/price-lists-controller-update-complexity';

@Injectable({ providedIn: 'root' })
export class SalesPriceListsService extends SalesBaseService {
  constructor(config: SalesApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `priceListsControllerFindAllByTenant()` */
  static readonly PriceListsControllerFindAllByTenantPath = '/o2-sales/price-lists/{tenant}';

  /**
   * Retrieve price lists by tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `priceListsControllerFindAllByTenant()` instead.
   *
   * This method doesn't expect any request body.
   */
  priceListsControllerFindAllByTenant$Response(params: PriceListsControllerFindAllByTenant$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<Array<SalesPriceListResponseDto>>> {
    const obs = priceListsControllerFindAllByTenant(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve price lists by tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `priceListsControllerFindAllByTenant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  priceListsControllerFindAllByTenant(params: PriceListsControllerFindAllByTenant$Params, context?: HttpContext): Observable<Array<SalesPriceListResponseDto>> {
    const resp = this.priceListsControllerFindAllByTenant$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<Array<SalesPriceListResponseDto>>): Array<SalesPriceListResponseDto> => r.body)
    );
  }

  /** Path part for operation `priceListsControllerCreate()` */
  static readonly PriceListsControllerCreatePath = '/o2-sales/price-lists/{tenant}';

  /**
   * Create a new price list.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `priceListsControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  priceListsControllerCreate$Response(params: PriceListsControllerCreate$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesPriceListResponseDto>> {
    const obs = priceListsControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a new price list.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `priceListsControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  priceListsControllerCreate(params: PriceListsControllerCreate$Params, context?: HttpContext): Observable<SalesPriceListResponseDto> {
    const resp = this.priceListsControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesPriceListResponseDto>): SalesPriceListResponseDto => r.body)
    );
  }

  /** Path part for operation `priceListsControllerFindOne()` */
  static readonly PriceListsControllerFindOnePath = '/o2-sales/price-lists/{tenant}/id/{id}';

  /**
   * Retrieve a price list by tenant and ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `priceListsControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  priceListsControllerFindOne$Response(params: PriceListsControllerFindOne$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesPriceListResponseDto>> {
    const obs = priceListsControllerFindOne(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a price list by tenant and ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `priceListsControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  priceListsControllerFindOne(params: PriceListsControllerFindOne$Params, context?: HttpContext): Observable<SalesPriceListResponseDto> {
    const resp = this.priceListsControllerFindOne$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesPriceListResponseDto>): SalesPriceListResponseDto => r.body)
    );
  }

  /** Path part for operation `priceListsControllerRemove()` */
  static readonly PriceListsControllerRemovePath = '/o2-sales/price-lists/{tenant}/{id}';

  /**
   * Delete a price list by tenant and ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `priceListsControllerRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  priceListsControllerRemove$Response(params: PriceListsControllerRemove$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesPriceListResponseDto>> {
    const obs = priceListsControllerRemove(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a price list by tenant and ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `priceListsControllerRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  priceListsControllerRemove(params: PriceListsControllerRemove$Params, context?: HttpContext): Observable<SalesPriceListResponseDto> {
    const resp = this.priceListsControllerRemove$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesPriceListResponseDto>): SalesPriceListResponseDto => r.body)
    );
  }

  /** Path part for operation `priceListsControllerUpdate()` */
  static readonly PriceListsControllerUpdatePath = '/o2-sales/price-lists/{tenant}/{id}';

  /**
   * Update a price list by tenant and ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `priceListsControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  priceListsControllerUpdate$Response(params: PriceListsControllerUpdate$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesPriceListResponseDto>> {
    const obs = priceListsControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a price list by tenant and ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `priceListsControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  priceListsControllerUpdate(params: PriceListsControllerUpdate$Params, context?: HttpContext): Observable<SalesPriceListResponseDto> {
    const resp = this.priceListsControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesPriceListResponseDto>): SalesPriceListResponseDto => r.body)
    );
  }

  /** Path part for operation `priceListsControllerAddComplexity()` */
  static readonly PriceListsControllerAddComplexityPath = '/o2-sales/price-lists/{tenant}/{id}/complexities';

  /**
   * Add a complexity to a price list.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `priceListsControllerAddComplexity()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  priceListsControllerAddComplexity$Response(params: PriceListsControllerAddComplexity$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesPriceListResponseDto>> {
    const obs = priceListsControllerAddComplexity(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Add a complexity to a price list.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `priceListsControllerAddComplexity$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  priceListsControllerAddComplexity(params: PriceListsControllerAddComplexity$Params, context?: HttpContext): Observable<SalesPriceListResponseDto> {
    const resp = this.priceListsControllerAddComplexity$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesPriceListResponseDto>): SalesPriceListResponseDto => r.body)
    );
  }

  /** Path part for operation `priceListsControllerRemoveComplexity()` */
  static readonly PriceListsControllerRemoveComplexityPath = '/o2-sales/price-lists/{tenant}/{id}/complexities/{complexityCode}';

  /**
   * Remove a complexity from a price list by code.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `priceListsControllerRemoveComplexity()` instead.
   *
   * This method doesn't expect any request body.
   */
  priceListsControllerRemoveComplexity$Response(params: PriceListsControllerRemoveComplexity$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesPriceListResponseDto>> {
    const obs = priceListsControllerRemoveComplexity(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Remove a complexity from a price list by code.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `priceListsControllerRemoveComplexity$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  priceListsControllerRemoveComplexity(params: PriceListsControllerRemoveComplexity$Params, context?: HttpContext): Observable<SalesPriceListResponseDto> {
    const resp = this.priceListsControllerRemoveComplexity$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesPriceListResponseDto>): SalesPriceListResponseDto => r.body)
    );
  }

  /** Path part for operation `priceListsControllerUpdateComplexity()` */
  static readonly PriceListsControllerUpdateComplexityPath = '/o2-sales/price-lists/{tenant}/{id}/complexities/{complexityCode}';

  /**
   * Update a complexity in a price list by code.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `priceListsControllerUpdateComplexity()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  priceListsControllerUpdateComplexity$Response(params: PriceListsControllerUpdateComplexity$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesPriceListResponseDto>> {
    const obs = priceListsControllerUpdateComplexity(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a complexity in a price list by code.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `priceListsControllerUpdateComplexity$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  priceListsControllerUpdateComplexity(params: PriceListsControllerUpdateComplexity$Params, context?: HttpContext): Observable<SalesPriceListResponseDto> {
    const resp = this.priceListsControllerUpdateComplexity$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesPriceListResponseDto>): SalesPriceListResponseDto => r.body)
    );
  }

  /** Path part for operation `priceListsControllerBootstrapPriceLists()` */
  static readonly PriceListsControllerBootstrapPriceListsPath = '/o2-sales/price-lists/bootstrap/{tenant}';

  /**
   * Bootstrap standard price lists for tenant.
   *
   * Creates standard price list categories and items from predefined templates. Automatically creates corresponding StandardTasks in Core service via SQS.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `priceListsControllerBootstrapPriceLists()` instead.
   *
   * This method doesn't expect any request body.
   */
  priceListsControllerBootstrapPriceLists$Response(params: PriceListsControllerBootstrapPriceLists$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesBootstrapPriceListsResponseDto>> {
    const obs = priceListsControllerBootstrapPriceLists(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Bootstrap standard price lists for tenant.
   *
   * Creates standard price list categories and items from predefined templates. Automatically creates corresponding StandardTasks in Core service via SQS.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `priceListsControllerBootstrapPriceLists$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  priceListsControllerBootstrapPriceLists(params: PriceListsControllerBootstrapPriceLists$Params, context?: HttpContext): Observable<SalesBootstrapPriceListsResponseDto> {
    const resp = this.priceListsControllerBootstrapPriceLists$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesBootstrapPriceListsResponseDto>): SalesBootstrapPriceListsResponseDto => r.body)
    );
  }

}
